import { fetch } from '@maxtropy/components';
import { DeviceType } from '@/shared/types';

export interface DeviceTypeTree {
  aliasName: string[];
  tree: DeviceType[];
}

export const getDeviceTypeTree = () =>
  fetch<DeviceTypeTree>(
    `/api/v2/deviceType/tree`,
    {
      method: 'POST',
    },
    true
  );
export const getLightDeviceTypeTree = () =>
  fetch<DeviceTypeTree>(
    `/api/v2/lightmap/tree`,
    {
      method: 'POST',
    },
    true
  );

// 太阳能路灯设备
export const getSunLightDeviceTypeTree = () =>
  fetch<DeviceTypeTree>(
    `/api/v2/lightmap/sunlight/tree`,
    {
      method: 'POST',
    },
    true
  );
// 车间照明设备
export const getWorkSpaceLightDeviceTypeTree = () =>
  fetch<DeviceTypeTree>(
    `/api/v2/lightmap/circuit/tree`,
    {
      method: 'POST',
    },
    true
  );

export const getDeviceTypeTreeWithoutScene = (params?: { flag?: boolean }) =>
  fetch<{ deviceTypes: DeviceType[] }>(
    `/api/v2/deviceType/treeWithoutScene`,
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );

export function getDeviceTypeSubList(id: number) {
  return fetch<{ list: DeviceType[] }>(
    `/api/v2/deviceType/subList`,
    {
      method: 'POST',
      body: JSON.stringify({ id }),
    },
    true
  );
}
